import { render, staticRenderFns } from "./VenteView.vue?vue&type=template&id=08b33b13&scoped=true"
import script from "./VenteView.vue?vue&type=script&lang=js"
export * from "./VenteView.vue?vue&type=script&lang=js"
import style0 from "./VenteView.vue?vue&type=style&index=0&id=08b33b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b33b13",
  null
  
)

export default component.exports